
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiSpeedFullLeft as ObiSpeedFullLeftElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-speed-full-left.js';
 
 
 

 
 export const ObiSpeedFullLeft = createComponent({
   react: React,
   tagName: 'obi-speed-full-left',
   elementClass: ObiSpeedFullLeftElement,
   events: {
     
   }
  });
 
 